import type { AlertItem } from '../../hooks/useAlerts';

function getNotificationIcon(type: string): string {
  switch (type) {
    case 'success': return 'ri-checkbox-circle-fill text-emerald-500';
    case 'warning': return 'ri-error-warning-fill text-amber-500';
    case 'info': return 'ri-information-fill text-blue-500';
    default: return 'ri-notification-fill text-gray-500';
  }
}

interface Props {
  notifications: AlertItem[];
  unreadCount: number;
  markRead: (id: string) => void;
  markAllRead: () => void;
  /** 列表最大高度类(桌面下拉用 max-h-96;移动全屏 sheet 用 flex-1 撑满) */
  listClassName?: string;
}

/**
 * 通知列表主体(可滚动列表 + 全部已读页脚)。
 * 桌面 Header 铃铛下拉与移动端「通知」Tab 共用,外层标题/定位由各自调用方提供。
 */
export default function NotificationList({
  notifications, unreadCount, markRead, markAllRead, listClassName = 'max-h-96',
}: Props) {
  return (
    <>
      <div className={`overflow-y-auto ${listClassName}`}>
        {notifications.length === 0 && (
          <div className="px-5 py-10 text-center text-sm text-gray-400">暂无通知</div>
        )}
        {notifications.map((notification) => (
          <div
            key={notification.id}
            onClick={() => notification.unread && markRead(notification.id)}
            className={`px-5 py-4 border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer ${
              notification.unread ? 'bg-blue-50/30' : 'opacity-60'
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-white shadow-sm flex-shrink-0">
                <i className={`${getNotificationIcon(notification.type)} text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="text-sm font-semibold text-gray-900">{notification.title}</h4>
                  {notification.unread && (
                    <div className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></div>
                  )}
                </div>
                <p className="text-sm text-gray-600 leading-relaxed mb-1">{notification.message}</p>
                <span className="text-xs text-gray-400">{notification.time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="px-5 py-3 bg-gray-50 border-t border-gray-100">
        <button
          onClick={markAllRead}
          disabled={unreadCount === 0}
          className="w-full text-sm font-medium text-teal-600 hover:text-teal-700 disabled:text-gray-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          全部标为已读
        </button>
      </div>
    </>
  );
}
